(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6146],{

/***/ 84531:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.CUSTOM_EVENTS = void 0;
(function (CUSTOM_EVENTS) {
    CUSTOM_EVENTS["CHAT_STATUS_CHANGED"] = "chat-status-changed";
    CUSTOM_EVENTS["CHAT_REQUEST"] = "chat-request";
})(exports.CUSTOM_EVENTS || (exports.CUSTOM_EVENTS = {}));


/***/ }),

/***/ 18243:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = __webpack_require__(67294);
const eventDefinitions = __webpack_require__(84531);
const types = __webpack_require__(30358);

const useChatStatus = () => {
    const [status, setStatus] = react.useState(getInitialStatus());
    react.useEffect(() => {
        function handleStatusChange(event) {
            setStatus(event.detail.status);
        }
        document.addEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        return () => {
            document.removeEventListener(eventDefinitions.CUSTOM_EVENTS.CHAT_STATUS_CHANGED, handleStatusChange);
        };
    }, []);
    return status;
};
function transformMetadataContext(metadataContext) {
    if (!metadataContext || typeof metadataContext !== 'object') {
        throw new Error('Invalid metadataContext provided');
    }
    return Object.entries(metadataContext).reduce((acc, [key, value]) => {
        acc[`context_${key}`] = value;
        return acc;
    }, {});
}
function triggerChat(triggerName, metadataContext) {
    if (!triggerName) {
        throw new Error('source name must be provided to trigger a chat');
    }
    const transformedMetadataContext = metadataContext ? transformMetadataContext(metadataContext) : undefined;
    document.dispatchEvent(new CustomEvent(eventDefinitions.CUSTOM_EVENTS.CHAT_REQUEST, {
        detail: {
            triggerName,
            metadataContext: transformedMetadataContext,
        },
    }));
}
function getInitialStatus() {
    return window.__CHAT_STATUS || types.SessionStatus.Idle;
}

Object.defineProperty(exports, "CUSTOM_EVENTS", ({
enumerable: true,
get: () => eventDefinitions.CUSTOM_EVENTS
}));
Object.defineProperty(exports, "ChatSourceName", ({
enumerable: true,
get: () => types.ChatSourceName
}));
Object.defineProperty(exports, "SessionStatus", ({
enumerable: true,
get: () => types.SessionStatus
}));
exports.triggerChat = triggerChat;
exports.useChatStatus = useChatStatus;


/***/ }),

/***/ 30358:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.SessionStatus = void 0;
(function (SessionStatus) {
    SessionStatus["Idle"] = "IDLE";
    SessionStatus["Started"] = "STARTED";
    SessionStatus["TalkingWithAgent"] = "TALKING_WITH_AGENT";
})(exports.SessionStatus || (exports.SessionStatus = {}));
exports.ChatSourceName = void 0;
(function (ChatSourceName) {
    ChatSourceName["AUTOMATION_REPORT_ISSUE"] = "automations_report_issue_button";
    ChatSourceName["AUTOMATION_CENTER"] = "automation-center";
    ChatSourceName["DIRECT_TRIGGERING_IN_PLATFORM"] = "direct_triggering";
    ChatSourceName["KNOWLEDGE_BASE_FLOATING_CHAT"] = "knowledge-base-floating-chat";
    ChatSourceName["HELP_CENTER_IN_APP"] = "HC_in_app";
    ChatSourceName["HELP_CENTER_V3"] = "help_center_v3";
    ChatSourceName["CONTACT_SALES_HOMEPAGE"] = "contact-sales-homepage";
})(exports.ChatSourceName || (exports.ChatSourceName = {}));


/***/ }),

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 21330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/directory-images-template-page",
      function () {
        return __webpack_require__(21762);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 48124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_addons_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/ouibounce/build/ouibounce.js
var ouibounce = __webpack_require__(5499);
var ouibounce_default = /*#__PURE__*/__webpack_require__.n(ouibounce);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-constants.js
var EXIT_POPUP_TEXT = {
    en: {
        TITLE: '"I want to hug the people that created this."',
        SUBTITLE: "- Emma J Coulson, with monday.com since 2014",
        SIGNUP_HEADER_TEXT: "Join 15,000+ teams who are passionate about monday.com",
        SIGNUP_INPUT_PLACEHOLDER: "Enter your work email",
        SIGNUP_BUTTON_TEXT: "Get free access now",
        SIGNUP_FOOTER_TEXT: "No thanks"
    },
    fr: {
        TITLE: "Vous n'avez pas le temps... Nous comprenons :)",
        SUBTITLE: "Envoyez-vous une invitation maintenant, et d\xe9butez quand vous avez 3 minutes",
        SIGNUP_INPUT_PLACEHOLDER: "Entrez votre adresse e-mail",
        SIGNUP_BUTTON_TEXT: "m'inviter"
    },
    es: {
        TITLE: "Est\xe1s ocupado... Te entendemos :)",
        SUBTITLE: "Env\xedate una invitaci\xf3n ahora y prueba monday.com cuando tengas 3 minutos",
        SIGNUP_INPUT_PLACEHOLDER: "Ingresa tu correo laboral",
        SIGNUP_BUTTON_TEXT: "Enviar"
    },
    de: {
        TITLE: "Du bist besch\xe4ftigt… wir verstehen das :)",
        SUBTITLE: "Sende dir jetzt selbst eine Einladung und probiere uns aus, wenn 3 Minuten Zeit hast",
        SIGNUP_INPUT_PLACEHOLDER: "Ihre Firmen-E-Mail-Adresse",
        SIGNUP_BUTTON_TEXT: "Mich selbst einladen"
    },
    it: {
        TITLE: "Sei impegnato... ti capiamo :)",
        SUBTITLE: "Mandati un auto-invito, e mettici alla prova quando hai 3 minuti liberi",
        SIGNUP_INPUT_PLACEHOLDER: "Inserisci la tua email aziendale",
        SIGNUP_BUTTON_TEXT: "Invita Me Stesso"
    }
};
var EXIT_POPUP_ORIGIN = "hp_exit_intent_modal";

// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.scss.js



var StyledModalBackgroundComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ebjt820"
})("position:fixed;width:100%;height:100%;background-color:", colors/* default.black */.Z.black, ";opacity:0.9;top:0;left:0;z-index:", z_index/* MODAL_BACKGROUND */.AE, ";");

;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.js


var ModalBackgroundComponent = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBackgroundComponent, {
        className: "modal-background",
        onClick: onClick
    });
};
/* harmony default export */ var modal_background_component = (ModalBackgroundComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.scss.js


var componentStyle = new String(".header-text.jsx-fb833f46e36abbce{margin-bottom:16px}");
componentStyle.__hash = "fb833f46e36abbce";
var signupBoxStyle = new String(".exit-popup-signup{.footer-text{cursor:pointer;color:darken(#fff,10%)}.exit-popup-signup-box{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.signup-form{margin-bottom:16px;margin-top:0}.signup-input{height:56px;width:224px;padding:0 24px;-webkit-border-radius:50px 0 0 50px;-moz-border-radius:50px 0 0 50px;border-radius:50px 0 0 50px;border:1px solid transparent;margin-right:0;color:".concat(colors/* default.black */.Z.black, ";vertical-align:bottom;font-size:.875rem;&:focus{outline:0}}.signup-button{height:56px;min-width:200px;background:#f4ce2f;-webkit-border-radius:0 50px 50px 0;-moz-border-radius:0 50px 50px 0;border-radius:0 50px 50px 0;border:1px solid transparent;padding:0 10px;color:#333;font-size:.875rem;vertical-align:bottom;&:hover{background:darken(#f4ce2f,5%);border:#f4ce2f}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.exit-popup-signup{.exit-popup-signup-box .signup-form-core-component-wrapper form{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;.signup-button-wrapper{width:auto;padding:8px 0 16px 0}}}}"));
signupBoxStyle.__hash = "98a26903dd2c2d5b";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.js











var ExitPopupSignup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupSignup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupSignup);
    function ExitPopupSignup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopupSignup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            value: ""
        };
        _this.onInputChange = _this.onInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopupSignup, [
        {
            key: "onInputChange",
            value: function onInputChange(e) {
                var value = e.target.value.value;
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerText = _props.headerText, inputPlaceholder = _props.inputPlaceholder, buttonText = _props.buttonText, footerText = _props.footerText, origin = _props.origin, onClickFooterText = _props.onClickFooterText;
                var value = this.state.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup",
                    children: [
                        headerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "header-text",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: inputPlaceholder,
                                ctaText: buttonText,
                                useCtaText: !!buttonText,
                                origin: origin,
                                forceDefaultForm: true
                            })
                        }),
                        footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: onClickFooterText,
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyle.__hash,
                            children: componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: signupBoxStyle.__hash,
                            children: signupBoxStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupSignup;
}(react.PureComponent);

ExitPopupSignup.defaultProps = {
    headerText: "Join <monday-paying-companies />+ teams who are passionate about monday.com",
    buttonText: "Get free access now",
    inputPlaceholder: "Enter your work email",
    footerText: "No thanks"
};

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.scss.js


var exit_popup_content_component_scss_componentStyle = new String(".exit-popup-content-component.jsx-c4034e412f97cb55{position:fixed;z-index:".concat(z_index/* MODAL_BACKGROUND */.AE + 1, ";left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:720px;padding:56px 40px 40px 40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background:#333;color:#fff;text-align:center;.content-title.jsx-c4034e412f97cb55{font-size:3vw;font-weight:500;margin:0}.content-subtitle.jsx-c4034e412f97cb55{font-size:1.2vw;margin-bottom:56px}}"));
exit_popup_content_component_scss_componentStyle.__hash = "c4034e412f97cb55";
var closeIconStyle = new String(".exit-popup-close.jsx-76784fb04befc36c{position:absolute;top:0;right:0;width:60px;height:60px;background:-webkit-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-moz-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-o-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);-webkit-border-radius:0px 0px 0px 5px;-moz-border-radius:0px 0px 0px 5px;border-radius:0px 0px 0px 5px;.x-button.jsx-76784fb04befc36c{position:absolute;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg);top:-4px;right:4px;line-height:1;font-size:2.25rem;color:#787878;-webkit-transition:color.1s ease-in-out;-moz-transition:color.1s ease-in-out;-o-transition:color.1s ease-in-out;transition:color.1s ease-in-out;text-decoration:none;cursor:pointer;&.jsx-76784fb04befc36c:hover,&.jsx-76784fb04befc36c:active,&.jsx-76784fb04befc36c:focus{color:#c4c4c4;text-decoration:none}}}");
closeIconStyle.__hash = "76784fb04befc36c";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.js









var ExitPopupContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupContent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupContent);
    function ExitPopupContent() {
        (0,_class_call_check/* default */.Z)(this, ExitPopupContent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ExitPopupContent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupHeaderText = _props.signupHeaderText, singupInputPlaceholder = _props.singupInputPlaceholder, signupButtonText = _props.signupButtonText, signupFooterText = _props.signupFooterText, onClose = _props.onClose, origin = _props.origin;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "nofollow",
                                onClick: onClose,
                                className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "x-button pointer tc",
                                children: "+"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-subtitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupSignup, {
                            headerText: signupHeaderText,
                            inputPlaceholder: singupInputPlaceholder,
                            buttonText: signupButtonText,
                            footerText: signupFooterText,
                            onClickFooterText: onClose,
                            origin: origin
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: exit_popup_content_component_scss_componentStyle.__hash,
                            children: exit_popup_content_component_scss_componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: closeIconStyle.__hash,
                            children: closeIconStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupContent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/localized-number-of-customers.js
var localized_number_of_customers = __webpack_require__(2522);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-component.js


















var ExitPopup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopup);
    function ExitPopup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isOpen: false
        };
        _this._ouibounce = null;
        _this.onExitIntent = _this.onExitIntent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClose = _this.onClose.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopup, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initOuibounce();
            }
        },
        {
            key: "initOuibounce",
            value: function initOuibounce() {
                var _props = this.props, timer = _props.timer, aggressive = _props.aggressive, sensitivity = _props.sensitivity, delay = _props.delay, cookieExpire = _props.cookieExpire, cookieDomain = _props.cookieDomain, cookieName = _props.cookieName;
                this._ouibounce = ouibounce_default()(false, {
                    timer: timer,
                    aggressive: aggressive,
                    sensitivity: sensitivity,
                    delay: delay,
                    cookieExpire: cookieExpire,
                    cookieDomain: cookieDomain,
                    cookieName: cookieName,
                    callback: this.onExitIntent
                });
            }
        },
        {
            key: "onExitIntent",
            value: function onExitIntent() {
                var abTests = this.props.abTests;
                if (!(0,acquisition_ab_test_service.shouldSeeReviveExitPopupAbTest)(abTests, true)) return;
                this.props.onExitIntentCallback && this.props.onExitIntentCallback();
                this.setState({
                    isOpen: true
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_OPEN);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.props.onCloseExitPopupCallback && this.props.onCloseExitPopupCallback();
                this.setState({
                    isOpen: false
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_CLOSE);
            }
        },
        {
            key: "render",
            value: function render() {
                var isOpen = this.state.isOpen;
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupConfig = _props.signupConfig, translate = _props.translate, translateWithParam = _props.translateWithParam, localeId = _props.localeId;
                var titleToUse = title || translate("exitPopup.title");
                var subtitleToUse = subtitle || translate("exitPopup.subtitle");
                var signupHeaderTextToUse = signupConfig && signupConfig.headerText || translateWithParam("exitPopup.signupTitle", (0,localized_number_of_customers/* getLocalizedNumberOfPayingTeams */.i)(localeId));
                var inputPlaceholderToUse = signupConfig && signupConfig.inputPlaceholder || translate("exitPopup.signupInputPlaceholder");
                var buttonTextToUse = signupConfig && signupConfig.buttonText || translate("exitPopup.signupButtonText");
                var footerTextToUse = signupConfig && signupConfig.footerText || translate("exitPopup.footerText");
                return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "exit-popup-overlay",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_background_component, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupContent, {
                            title: titleToUse,
                            subtitle: subtitleToUse,
                            signupHeaderText: signupHeaderTextToUse,
                            singupInputPlaceholder: inputPlaceholderToUse,
                            signupButtonText: buttonTextToUse,
                            signupFooterText: footerTextToUse,
                            onClose: this.onClose,
                            origin: EXIT_POPUP_ORIGIN
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
            }
        }
    ]);
    return ExitPopup;
}(react.PureComponent);
ExitPopup.defaultProps = {
    timer: 100,
    aggressive: false,
    sensitivity: 5,
    delay: 200,
    cookieExpire: 30,
    cookieDomain: ".monday.com",
    cookieName: cookies.VIEWED_OUI_BOUNCE_MODAL_COOKIE
};
/* harmony default export */ var exit_popup_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(ExitPopup)));

// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
;// CONCATENATED MODULE: ./components/addons/core-addons/core-addons-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var CoreAddonsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CoreAddonsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CoreAddonsComponent);
    function CoreAddonsComponent() {
        (0,_class_call_check/* default */.Z)(this, CoreAddonsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CoreAddonsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                //TODO: Remove and change GTM trigger to page load
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SHOW_COOKIEHUB_DIALOG_EVENT_NAME);
            //If we see that CookieHub Geolocation isn't working well we can fire a GTM event only for relevant countries + another for the rest to launch all cookies
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, exitPopupConfig = _props.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: exitPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(exit_popup_component, _object_spread({}, exitPopupConfig))
                });
            }
        }
    ]);
    return CoreAddonsComponent;
}(react.PureComponent);
/* harmony default export */ var core_addons_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(CoreAddonsComponent)));


/***/ }),

/***/ 9644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DirectoryImagesTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/templates/base-template.js + 50 modules
var base_template = __webpack_require__(66387);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/core/directory/index.js + 21 modules
var directory = __webpack_require__(76291);
// EXTERNAL MODULE: ./constants/thumbnails-types.js
var thumbnails_types = __webpack_require__(50432);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/templates/directory-images-template/directory-images-template.scss.js


var StyledDirectoryTemplateComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed2kd5h0"
})(".directory-component-wrapper{background-color:#f5f5f5;padding-top:80px;}nav.navbar{background-color:", colors/* default.white */.Z.white, " !important;}");

// EXTERNAL MODULE: ./services/directories-service.js
var directories_service = __webpack_require__(37221);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 81 modules
var base_header_component = __webpack_require__(33782);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
;// CONCATENATED MODULE: ./components/templates/directory-images-template/directory-images-template.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









 //new for monday 2.0
 // //new for monday 2.0
var DirectoryImagesTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryImagesTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryImagesTemplate);
    function DirectoryImagesTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, DirectoryImagesTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            searchValue: null
        };
        _this.onSearchChange = _this.onSearchChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.filterValidator = _this.filterValidator.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(DirectoryImagesTemplate, [
        {
            key: "onSearchChange",
            value: function onSearchChange(value) {
                this.setState({
                    searchValue: value
                });
            }
        },
        {
            key: "filterValidator",
            value: function filterValidator(item) {
                var searchValue = this.state.searchValue;
                return (0,directories_service/* itemFilterValidator */.P)(item, searchValue);
            }
        },
        {
            key: "render",
            value: function render() {
                var exitPopup = this.props.exitPopup;
                var _pageConfig = this.props.pageConfig, header = _pageConfig.header, listData = _pageConfig.listData, socialButtons = _pageConfig.socialButtons, topBanner = _pageConfig.topBanner, exitPopupConfig = _pageConfig.exitPopupConfig;
                var searchValue = this.state.searchValue;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, _object_spread_props(_object_spread({}, this.props, this.props.pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryTemplateComponent, {
                        className: "directory-template-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                                allowSocialButtons: socialButtons && socialButtons.show,
                                socialButtonsColor: socialButtons && socialButtons.color,
                                socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                                topBanner: topBanner,
                                maxWidth: "100%",
                                showMenu: true,
                                headerBackgroundColor: "white"
                            }),
                            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(directory/* DirectoryHeaderComponent */.bS, _object_spread_props(_object_spread({}, header), {
                                searchValue: searchValue,
                                onSearchChange: this.onSearchChange
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "directory-component-wrapper",
                                id: element_ids/* MAIN_ID */.k,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(directory/* DirectoryComponent */.wm, {
                                    filterTerm: searchValue,
                                    tuhmbnailsListData: listData,
                                    thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_IMAGE */.H.BACKGROUND_IMAGE,
                                    filterValidator: this.filterValidator
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                exitPopup: exitPopup,
                                exitPopupConfig: exitPopupConfig
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return DirectoryImagesTemplate;
}(react.PureComponent);

DirectoryImagesTemplate.defaultProps = {
    exitPopup: true,
    pageConfig: {
        header: {
            color: "brand-red",
            text: "sdkhjdsjhkds",
            height: "360px",
            img: "/static/img/strips/strip-computer-coffee.png"
        },
        listData: [],
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        }
    }
};


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ HEADER_POPUP_OPTIONS; },
/* harmony export */   "Yq": function() { return /* binding */ HEADER_POPUP_DATA; }
/* harmony export */ });
/* unused harmony exports RING_THE_BELL_VALUE, IPO_BLOG_POST_VALUE, ELEVATE_REGISTRATION_VALUE, RING_THE_BELL_TEXT, IPO_BLOG_POST_TEXT, ELEVATE_REGISTRATION_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);




var RING_THE_BELL_VALUE = "ring_the_bell";
var IPO_BLOG_POST_VALUE = "ipo_blog_post";
var ELEVATE_REGISTRATION_VALUE = "elevate_registration";
var RING_THE_BELL_TEXT = "Ring the bell";
var IPO_BLOG_POST_TEXT = "IPO blog post";
var ELEVATE_REGISTRATION_TEXT = "Elevate Registration";
var HEADER_POPUP_OPTIONS = [
    {
        value: RING_THE_BELL_VALUE,
        text: RING_THE_BELL_TEXT
    },
    {
        value: IPO_BLOG_POST_VALUE,
        text: IPO_BLOG_POST_TEXT
    },
    {
        value: ELEVATE_REGISTRATION_VALUE,
        text: ELEVATE_REGISTRATION_TEXT
    }
];
var CLOUDINARY_BELL_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/ipo/ipo-bell-gif.gif";
var ELEVATE_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/elevate/star-rect.gif";
var ELEVATE_MOBILE_IMAGE_SRC = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/elevate/star-static.png";
var getRingTheBellLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .RING_THE_BELL_VIDEO_LINK */ .Kk$;
};
var getIpoBlogPostLink = function(locale) {
    switch(locale){
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.SPANISH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_SPANISH_LINK */ .zjT;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.PORTUGEESE_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_PORTUGESE_LINK */ .aL4;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.GERMAN_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_GERMAN_LINK */ .mF0;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.FRENCH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_FRENCH_LINK */ .div;
        default:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_LINK */ .vWk;
    }
};
var getElevateRegitrationLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ELEVATE_MAIN_PAGE_LINK */ .Csm;
};
var _obj;
var HEADER_POPUP_DATA = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, RING_THE_BELL_VALUE, {
    textKey: "header.ipo.popup.ringTheBell.mainText",
    ctaKey: "header.ipo.popup.ringTheBell.cta",
    getLink: getRingTheBellLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, IPO_BLOG_POST_VALUE, {
    textKey: "header.ipo.popup.ipoBlogPost.mainText",
    ctaKey: "header.ipo.popup.ipoBlogPost.cta",
    getLink: getIpoBlogPostLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ELEVATE_REGISTRATION_VALUE, {
    textKey: "header.elevate.popup.mainText",
    mobileTextKey: "header.elevate.popup.mobileText",
    ctaKey: "header.elevate.popup.cta",
    getLink: getElevateRegitrationLink,
    popupClassName: "elevate",
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .GRADIANT_ELEVATE_THEME_ID */ .wk,
    gifSrc: ELEVATE_GIF_SRC,
    mobileImageSrc: ELEVATE_MOBILE_IMAGE_SRC
}), _obj);


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);








var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 21762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ DirectoryImagesTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_directory_images_template_directory_images_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9644);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var DirectoryImagesTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(DirectoryImagesTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DirectoryImagesTemplatePage);
    function DirectoryImagesTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, DirectoryImagesTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(DirectoryImagesTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_directory_images_template_directory_images_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return DirectoryImagesTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}












var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig, setStartShowingStickyHeader = props.setStartShowingStickyHeader, isInView = props.isInView;
    (0,react.useEffect)(function() {
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7229,6602,390,8559,5365,4778,677,9359,5657,932,4494,4961,1068,3211,9952,9160,2849,1373,3203,8885,3050,6227,3782,7401,9774,2888,179], function() { return __webpack_exec__(21330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);